import { createReducer } from "@reduxjs/toolkit";
import { retrieveLessons } from "./retrieve-lessons";
import { teacherRequestTeacherPayout } from "@academy-context/write/application/use-cases/teacher/teacher-payout-request/request-teacher-payout";
import type { RetrievalState } from "@redux/state/shared-types";
import type { TeacherLessonListVM } from "@shared-kernel/application/ports/teacher/teacher-repository";

const initialState: RetrievalState<TeacherLessonListVM[]> = { fetching: "idle", data: [] };

export const retrieveLessonsReducer = createReducer<RetrievalState<TeacherLessonListVM[]>>(initialState, builder => {
  builder.addCase(retrieveLessons.fulfilled, (state, { payload }) => {
    return {
      ...state,
      data: payload,
      fetching: "success",
    };
  });
  builder.addCase(retrieveLessons.pending, state => {
    return {
      ...state,
      fetching: "pending",
    };
  });
  builder.addCase(retrieveLessons.rejected, state => {
    return {
      ...state,
      fetching: "failed",
    };
  });
  builder.addCase(teacherRequestTeacherPayout.fulfilled, state => {
    return {
      ...state,
      data: [],
    };
  });
});
